/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import * as S from './style';
import * as T from '../Typography';
import Image from '../PreviewCompatibleImage';

const Steps = ({ image, title, description, ...props }) => (
  <S.Wrapper {...props}>
    <S.ImageWrapper {...props}>
      <Image width="100%" image={image} style={{ height: '100%' }} />
    </S.ImageWrapper>
    <S.Body>
      <T.H4SemiBold color="midnight" mt={2} ta="center" taT="center" taM="center">
        {title}
      </T.H4SemiBold>
      <T.P16 color="black3" mt={1} ta="center" taT="center" taM="center">
        {description}
      </T.P16>
    </S.Body>
  </S.Wrapper>
);

Steps.propTypes = {
  category: PropTypes.string,
};

export default Steps;
